import { Component, OnInit, ViewChild, OnChanges, OnDestroy, ViewChildren, QueryList, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { PhBhpFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-filter/ph-bhp-filter.component';
import { Subscription } from 'rxjs';
import { SopDetail } from 'ph-bhp-feature-packages/ph-bhp-feature-package-elearning/lib/Models';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageEvaluationFilterService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluationfilter.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PhBhpBarChartComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import cloneDeep from 'lodash/cloneDeep';
import { PhpBhpCheckChartExportComponent } from '../php-bhp-check-chart-export/php-bhp-check-chart-export.component';
import { PhBhpPdfComplianceMultiFilterCheckComponent } from '../ph-bhp-pdf-compliance-multi-filter-check/ph-bhp-pdf-compliance-multi-filter-check.component';
@Component({
  selector: 'app-hygiene-check-evaluation-quickcomments',
  templateUrl: './hygiene-check-evaluation-quickcomments.component.html',
  styleUrls: ['./hygiene-check-evaluation-quickcomments.component.css']
})
export class HygieneCheckEvaluationQuickcommentsComponent implements OnInit {
  translationKeys: typeof TranslationKeys = TranslationKeys;
  private static readonly INITIAL_FIELDS = [
    { 'field': 'title', 'title': 'CONFIGURE.DESCRIPTION', 'group': '' }
  ];
  reportKey: string = 'QuickCommentsAnalysis';
  pageTitle: string;
  textLegend: string;
  langSubscription: Subscription;
  institutionSubscription: Subscription;
  compareCard;
  tempFilter;
  showCompareCard;
  singleCard;
  data;
  filterDetails = [];
  isDesktop = true;
  isAdjustableHeight = true;
  @ViewChild('compliance', { static: true }) compliance: PhBhpPdfComplianceMultiFilterCheckComponent;
  @ViewChild('exportTag', { static: true }) exportTag: PhpBhpCheckChartExportComponent;
  @ViewChild('multiselect', { static: true }) multiselect: any;
  @ViewChildren(PhBhpFilterComponent) filters: QueryList<PhBhpFilterComponent>;
  @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
  initFlag = true;
  sopiDs: Array<any> = [];
  isSavedFromEvaluation: boolean;
  noDataFound: boolean = false;
  percentageLegend = "{0}%";
  labels;
  pageInfo = {
    ofLabel: 'GENERAL.OF',
    items: 'GENERAL.ITEMS',
    itemsPerPageLabel: 'GENERAL.ITEMS_PAGE'
  };
  userData: any;
  public clickImageBtn = false;
  public clickExcelBtn = false;
  public clickPdfBtn = false;

  sopDetail: SopDetail[];

  userSubscription: Subscription;
  //'5 Moments';
  userID;
  roleId;
  appName = 'Hygiene Check';
  filterIndices: number[] = [0];
  evaluationLoaded: boolean = false;
  originalData: any;
  quickCommentsResponse: any;
  isEvaluationTable: boolean = true;

  multiSelectText: string = '';
  results: any = [];
  isUserFilterSetted: boolean = false;
  userHasFilter: boolean = false;
  userFilters: any;
  sopFilters: any[] = [];
  questionnaires: { id: string, questionnaireName: string, institutionName: string }[] = [];
  fields: any[] = [...HygieneCheckEvaluationQuickcommentsComponent.INITIAL_FIELDS];
  gridData: Array<any>;
  comments: { id: string, title: string, institutionId: number, institutionName: string }[] = [];  selectedQuestionnaires: any[] = [];
  originalComments: { id: string, title: string, institutionId: number, institutionName: string }[] = [];
  originalFields: any[] = null;
  selectedSeries: any[] = [];
  selectedComment: any = { id: "", name: "" };

  constructor(
    public appConfig: AppConfig,
    private router: Router,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    private layoutService: PHBHPLayoutPackageService,
    private filterService: PHBHPFeaturePackageEvaluationFilterService,
    private elRef: ElementRef) {
    this.textLegend = this.layoutService.translateText("CHECK.EVALUATION.QUICK_COMMENTS");
    this.appConfig.filterDetails ? this.filterDetails = this.appConfig.filterDetails : this.filterDetails = [];
  }

  private scrollListener: any;
  ngAfterViewInit() {
    this.scrollListener = (event) => {
      const dropdownMenu = event.target as HTMLElement;
      if (dropdownMenu.classList.contains('dropdown-menu')) {
        return;
      }
      this.checkDropdownPositions(event);
    };

    document.addEventListener('scroll', this.scrollListener, true);
  }

  checkDropdownPositions(event) {
    const dropdowns: NodeListOf<HTMLElement> = this.elRef.nativeElement.querySelectorAll('.dropdown-container-input');
    const scrollTop = event.target.scrollTop || document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = window.innerHeight;

    dropdowns.forEach(dropdown => {
      const rect = dropdown.getBoundingClientRect();
      const top = rect.top + scrollTop;
      if (top < scrollTop || top + rect.height > scrollTop + windowHeight) {
        if (dropdown.getAttribute('aria-expanded') === 'true') {
          dropdown.dispatchEvent(new Event('click'));
        }
      }
    });
  }

  ngOnInit(): void {
    this.userID = this.appConfig.userData.userId;
    this.roleId = this.appConfig.userData.roleName.roleId;
    this.userData = this.appConfig.userData;
    this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
      setTimeout(() => {
        for (let i = 0; i < this.charts.length; i++) {
          let chart = this.charts.get(i);
          chart.chartOptions.valueAxis.title.text = this.textLegend;
        }

        this.pageTitle = this.layoutService.translateText("CHECK.EVALUATION.QUICK_COMMENTS");
        this.compliance.complianceTitle = this.layoutService.translateText("CHECK.EVALUATION.QUICK_COMMENTS");
        if (this.userHasFilter) {
          this.evaluate(true);
        } else {
          this.layoutService.showLoader = false;
        }
      }, 1000);
    });

    this.pageTitle = this.layoutService.translateText("CHECK.EVALUATION.QUICK_COMMENTS");
    this.compliance.complianceTitle = this.layoutService.translateText("CHECK.EVALUATION.QUICK_COMMENTS");
    this.ngOnChanges();
  }

  onMultiselectChange(event) {
    if (this.selectedQuestionnaires.length == 0) {
      this.comments = this.originalComments;
    } else {
      this.comments = this.originalComments.filter(res => {
        return this.selectedQuestionnaires.some(q => q.institutionName == res.institutionName);
      });
    }

    this.layoutService.showLoader = true;
    this.evaluate(true);
  }

  resetQuestionnaireFilter() {
    this.comments = this.originalComments;
    this.selectedQuestionnaires = [];
    this.compliance.selectedQuestionnaires = this.selectedQuestionnaires;
    this.layoutService.showLoader = true;
    this.evaluate(true);
  }

  ngOnChanges() {
    this.layoutService.showLoader = true;
    this.userHasFilter = false;
    if (!this.isUserFilterSetted) {
      const countryId = this.appConfig.userData.roleName.roleId == 1 ? '0' : this.appConfig.userData.country;
      var questionnairesPromise = this.evaluationService.getQuestionnairesByUserAndCountry(this.appConfig.userData.userId, countryId).toPromise();
      var commentsPromise = this.evaluationService.getCommentsByUserAndCountry(this.appConfig.userData.userId, countryId).toPromise();
      var userHasFilterPromise = this.evaluationService.getUserHasCheckEvaluationFilter(this.appConfig.userData.userId, this.reportKey).toPromise();
      Promise.all([questionnairesPromise, commentsPromise, userHasFilterPromise]).then((results) => {
        this.questionnaires = results[0];
        this.originalComments = results[1];
        this.comments = results[1];
        var userHasFilter = results[2];
        if (this.appConfig.checkGeneralFilter != null) {
          userHasFilter = this.appConfig.checkGeneralFilter;
        }

        this.isUserFilterSetted = true;
        if (userHasFilter) {
          if (userHasFilter.questionnaireIds && userHasFilter.questionnaireIds.length > 0) {
            var selectedQuestionnaires = userHasFilter.questionnaireIds.map((id) => {
              var questionnaire = this.questionnaires.find(questionnaire => questionnaire.id == id);
              if (questionnaire) {
                return {
                  id: questionnaire.id,
                  questionnaireName: questionnaire.questionnaireName,
                  institutionName: questionnaire.institutionName
                }
              } else {
                return null;
              }
            });

            this.selectedQuestionnaires = selectedQuestionnaires.filter(res => res != null);
            this.compliance.selectedQuestionnaires = this.selectedQuestionnaires;
            if (this.selectedQuestionnaires.length == 0) {
              this.comments = this.originalComments;
            } else {
              this.comments = this.originalComments.filter(res => {
                return this.selectedQuestionnaires.some(q => q.institutionName == res.institutionName);
              });
            }
          } else {
            this.selectedQuestionnaires = [];
          }

          if (userHasFilter.commentIds && userHasFilter.commentIds.length > 0) {
            var comment = this.comments.find(res => res.id.toLowerCase() == userHasFilter.commentIds[0].toLowerCase());
            if (comment) {
              this.onCommentChange(comment, false);
            } else {
              this.onCommentChange(0, false);
            }
          } else {
            this.onCommentChange(0, false);
          }

          this.userHasFilter = true;
          this.userFilters = userHasFilter.filters;
          setTimeout(() => { this.initComponent(); });
        } else {
          this.layoutService.showLoader = false;
          this.onCommentChange(0, false);
          this.userFilters = [];
          this.noDataFound = true;
          this.filters.get(0).showFilter(true);
          this.compliance.resultsLoader.next([{}]);
        }
      }, (error) => { this.layoutService.showLoader = false; });
    } else {
      setTimeout(() => { this.initComponent(); });
    }
  }

  ngOnDestroy() {
    if (this.langSubscription)
      this.langSubscription.unsubscribe();
    if (this.userSubscription)
      this.userSubscription.unsubscribe();
    if (this.institutionSubscription)
      this.institutionSubscription.unsubscribe();
    if (this.scrollListener)
      document.removeEventListener('scroll', this.scrollListener, true);
  }

  initComponent() {
    if (this.userFilters.length > 0) {
      this.userFilters.forEach((filter, idx) => {
        if (!filter.filterName || filter.filterName.trim() === "") {
          filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
        }
      });
      this.filterIndices = this.userFilters.map((_, index) => index);
      this.showCompareCard = this.filterIndices.length > 1;
    }

    if (this.appConfig.userData) {
      for (let i = 0; i < this.charts.length; i++) {
        let chart = this.charts.get(i);
        chart.chartOptions.valueAxis.labels = {
          format: this.percentageLegend
        };
        chart.chartOptions.valueAxis.title = {
          text: this.layoutService.translateText("CHECK.EVALUATION.QUICK_COMMENTS"),
          font: "9px OpenSans-Regular"
        };
      }

      this.compliance.showFilter = true;
      this.compliance.complianceTitle = this.pageTitle;
      this.compliance.roleId = this.roleId;
      this.compliance.fillWith = 'N/A';
      this.loadFiltersInfo();
      if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.tempFilter = this.userFilters;
      }

      this.evaluate(true, true);
    }
  }

  evaluate(getResults, initialize?) {
    this.data = {
      filters: [],
      roleId: this.roleId,
      questionnaireIds: this.selectedQuestionnaires.length > 0 ? this.selectedQuestionnaires.map(res => res.id) : [],
      commentIds: this.selectedComment.id === "all" ? [] : [this.selectedComment.id],
    };

    if (this.data.questionnaireIds && this.data.questionnaireIds.length > 0) {
      this.compliance.selectedQuestionnaires = this.selectedQuestionnaires.map((res) => {
        var questionnaire = this.questionnaires.find(questionnaire => questionnaire.id == res.id);
        return {
          id: questionnaire.id,
          questionnaireName: questionnaire.questionnaireName,
          institutionName: questionnaire.institutionName
        }
      });
    } else {
      this.compliance.selectedQuestionnaires = [
        { questionnaireName: "CHECK.EVALUATION.ALL_QUESTIONNAIRES" }
      ]
    }

    if (this.data.commentIds && this.data.commentIds.length > 0) {
      this.compliance.selectedComments = [this.selectedComment.title];
    } else {
      this.compliance.selectedComments = ["CHECK.EVALUATION.ALL_COMMENTS"];
    }

    if (initialize) {
      this.data.filters = this.userFilters;
    } else {
      const countryId = this.appConfig.userData.roleName.roleId == 1 ? '0' : this.appConfig.userData.country;

      this.filters.forEach((filter) => {
        let filterData: any = {
          startDate: filter.range.start,
          endDate: filter.range.end,
          instutionIDs: "",
          departmentID: "",
          wardID: "",
          professionalCategoryID: "",
          subprofessionalCategoryID: "",
          countryID: countryId
        };

        if (this.roleId == 1 && filter.setCountry != 0) {
          filterData.countryID = filter.setCountry.countryID
        }

        filterData = filter.assignData(filterData);
        this.data.filters.push(filterData);
        if (filterData.multiSelectName) {
          this.multiSelectText = filterData.multiSelectName;
        }
      });
    }

    this.compliance.setFilters(this.filters.toArray());
    this.userHasFilter = true;
    if (getResults == true) {
      this.getCheckCommentsAnalysis(this.userID, this.data);
    } else if (getResults == false) {
      this.saveCheckCommentsAnalysis(this.userID, this.data)
    }
  }

  async loadFiltersInfo() {
    setTimeout(() => {
      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
            filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.wardID));
          }

          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiselectFilter, filter.multiselectValues, true);
          }
        }
      });
    }, 500);
  }

  resetExportAs(value: 'image' | 'excel' | 'pdf') {
    switch (value) {
      case 'image':
        this.clickImageBtn = false;
        break;
      case 'excel':
        this.clickExcelBtn = false;
        break;
      case 'pdf':
        this.clickPdfBtn = false;
        break;
    }
  }

  emitData(valve) {
    if (valve.value) {
      this.appConfig.checkGeneralFilter = this.data;
      this.appConfig.dropdownChanged = "changed";
    } else {
      this.appConfig.filterDetails = [];
      this.appConfig.checkGeneralFilter = null;
    }

    switch (valve.key) {
      case 'back': this.router.navigate(['evaluation/hygiene-check/statistical']); break;
      case 'quickCommentsAnalysis': this.router.navigate(['evaluation/hygiene-check/quickComments']); break;
      case 'overallComplianceScore': this.router.navigate(['evaluation/hygiene-check/overallCompliance']); break;
      case 'individualAuditDataOverview': this.router.navigate(['evaluation/hygiene-check/individualData']); break;
      default: this.router.navigate(['evaluation/hygiene-check/statistical']); break;
    }
  }

  filterCompare() {
    this.compareCard = false;

    if (this.filterIndices.length < 6) {
      this.filterIndices.push(this.filterIndices.length);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    this.layoutService.showLoader = true;
    setTimeout(() => {
      var filters = this.filters.toArray();
      filters[filters.length - 1].setInfoFromFilter(cloneDeep(cloneDeep(filters[filters.length - 2])));
      this.layoutService.showLoader = false;
    }, 500);

    if (!this.userHasFilter) {
      this.filters.get(0).showFilter(true);
      return;
    }
  }

  showFilter(cardType) {
    const showFilter = cardType;
    if (showFilter == 'singleCard') {
      this.singleCard = !this.singleCard;
      this.compareCard = false;
    }
    if (showFilter == 'compareCard') {
      this.compareCard = !this.compareCard
      this.singleCard = false;
    }
  }

  cancelFilter() {
    this.singleCard = false;
    this.compareCard = false;
  }

  saveCheckCommentsAnalysis(userID, data) {
    this.isSavedFromEvaluation = false;
    this.layoutService.showLoader = true;
    var selectedSeries = JSON.stringify(Array.from(this.selectedSeries))
    this.data.selectedSeries = selectedSeries;
    this.evaluationService.saveCheckSummarisedDetails(userID, this.isSavedFromEvaluation, this.reportKey, data).subscribe((res: any) => {
      this.layoutService.showLoader = false;
      this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
    })
  }

  getCheckCommentsAnalysis(userID, data) {
    this.isSavedFromEvaluation = true;
    this.layoutService.showLoader = true;
    this.evaluationService.getCheckQuickCommentsAnalysis(userID, this.isSavedFromEvaluation, this.reportKey, data).subscribe((res: any) => {
      this.originalData = JSON.parse(JSON.stringify(res));
      this.quickCommentsResponse = res;
      this.buildChart(this.quickCommentsResponse);
    })
  }

  setFilterDetails() {
    if (this.filterDetails.length > 0) {
      if (this.filters) {
        this.filterService.setFiltersValue(this.filterDetails, this.filters.toArray());
      }
    }
  }

  createFilterData(userID: number) {
    const defaultFilterData = {
      startDate: new Date(),
      endDate: new Date(),
      instutionIDs: "",
      departmentID: "",
      wardID: "",
      professionalCategoryID: "",
      subprofessionalCategoryID: "",
      countryID: 0
    };

    const filters = this.filters && this.filters.length > 0 ? this.filters.map(filter => {
      let filterData = { ...defaultFilterData, startDate: filter.range.start, endDate: filter.range.end };
      if (this.roleId === 1 && filter.setCountry !== 0) {
        filterData.countryID = filter.setCountry.countryID;
      }
      return filter.assignData(filterData);
    }) : [defaultFilterData];

    return {
      filter: filters,
      countryID: 0,
      isBenchMark: true,
      userId: userID,
      isSavedFromEvaluation: true,
      roleId: this.roleId
    };
  }

  updateFilters(filters) {
    this.filterIndices = filters.filter.map((_, index) => index);
    this.filters.toArray().forEach((filterComponent, index) => {
      if (filters.filter[index]) {
        let startDate = new Date(filters.filter[index].startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filters.filter[index].endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        filterComponent.setCountryFilter(filters.filter[index].countryID, filters.filter[index].instutionIDs, filters.filter[index].wardID, true);
        filterComponent.setDepartmentFilter(filters.filter[index].departmentID, true);
        filterComponent.setDepartmentTypeFilter(filters.filter[index].departmentTypeID, true);
        filterComponent.setProfessionalCategory(filters.filter[index].professionalCategoryID, filters.filter[index].subprofessionalCategoryID, true);
      }
    });

    setTimeout(() => {
      this.compliance.setFilters(this.filters.toArray());
    }, 1000);

    if (filters.filter.length >= 2 && this.isDesktop) {
      this.showCompareCard = this.filterIndices.length > 1;
      this.compliance.showCompareCard = this.showCompareCard;
      this.tempFilter = filters;
    }
  }

  ngAfterViewChecked() {
    if (this.tempFilter) {
      var tempFilter = this.tempFilter;
      this.tempFilter = undefined;

      this.userFilters.forEach((filter, index) => {
        let filterComponent = this.filters.toArray()[index];
        let startDate = new Date(filter.startDate);
        startDate = new Date(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
        let endDate = new Date(filter.endDate);
        endDate = new Date(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());
        filterComponent.dateRange = [startDate, endDate];
        filterComponent.selectDate();
        if (this.roleId == 1) {
          filterComponent.setSAFilter(filter, true);
        } else {
          filterComponent.setFilterNameFilter(filter.filterName, true);
          filterComponent.setCountryFilter(filter.CountryID, '', '', true);
          filterComponent.setInstitutionsByID(filter.instutionIDs, true);
          filterComponent.setDepartmentFilter(filter.departmentID, true);
          filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
          filterComponent.setProfessionalCategory(filter.professionalCategoryID, filter.subprofessionalCategoryID, true);
          if (filter.multiselect) {
            filterComponent.setMultiFilter(filter.multiselect, filter.multiselectFilter, filter.multiselectValues, true);
          }
        }
      });
    }
  }

  buildChart(res) {
    this.evaluationLoaded = false;
    var colors = [
      "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
    ];

    let chart: PhBhpBarChartComponent;
    this.fields = [...HygieneCheckEvaluationQuickcommentsComponent.INITIAL_FIELDS];
    this.results = [];
    const categoryTitle: string = 'DASHBOARD.TOTAL_PERCENT_COMPLIANCE';
    res.forEach(result => {
      if (result.quickCommentsAnalysisList.length > 0) {
        let id = result.filterType || 'single';
        if (this.results.findIndex(r => r.id === id) === -1) {
          this.results.push({
            id,
            quickCommentsAnalysisList: [],
            gridData: [],
            fields: [...HygieneCheckEvaluationQuickcommentsComponent.INITIAL_FIELDS],
            noDataFound: true
          });
        }
      }
    });

    this.compliance.resultsLoader.next(Object.assign([], this.results));
    // The timeout is necessary to give the chart QueryList time to load the component
    setTimeout(() => {
      let filterCount: number = 0;
      let filterTableCount: number = 0;
      res.forEach((quickCommentsAnalysis: any, index) => {
        let chartId = quickCommentsAnalysis.filterType || 'single';
        quickCommentsAnalysis.filterType = chartId;
        let chartIndex = this.results.findIndex(r => r.id === chartId);
        chart = this.charts.get(chartIndex);
        let data = JSON.parse(JSON.stringify(chart.chartOptions));

        if (!data.setId) {
          data.nextIndex = 0;
          data.categoryAxis.categories = [];
          data.categoryAxis.categoryOffset = [];
          data.series = [];
          data.seriesIdentifier = [];
        }

        data.series[data.nextIndex] = { data: [], name: [], dataOffset: [], serieIndex: index };
        data.series[data.nextIndex].color = colors[index];
        data.seriesIdentifier[data.nextIndex] = [];
        chart.chartId = chartId;

        if (quickCommentsAnalysis.quickCommentsAnalysisList.length === 1 && quickCommentsAnalysis.quickCommentsAnalysisList[0].list.length === 0 && chart.noDataFound) {
          this.noDataFound = true;
          chart.noDataFound = true;
        } else {
          if (quickCommentsAnalysis.quickCommentsAnalysisList.length === 2 && quickCommentsAnalysis.quickCommentsAnalysisList[0].list.length === 0 && chart.noDataFound) {
            this.noDataFound = true;
            chart.noDataFound = true;
          } else {
            this.results[chartIndex].noDataFound = false;
            this.noDataFound = false;
            chart.noDataFound = false;
          }
        }

        if (this.comments.length === 0) {
          this.results[chartIndex].noDataFound = true;
            this.noDataFound = false;
            chart.noDataFound = true;
        }

        quickCommentsAnalysis.quickCommentsAnalysisList.forEach((quickComments) => {
          let quickCommentsItem = quickComments;
          data.series[data.nextIndex].dataSetId = quickCommentsItem.id;
          quickCommentsItem.list.forEach((comment) => {
            if (this.data.commentIds.length > 0) {
              if (!this.data.commentIds.includes(comment.id)) {
                return;
              }
            }

            if (this.comments.length > 0) {
              if (this.comments.findIndex(res => res.id == comment.id) == -1) {
                return;
              }
            } else {
              return;
            }

            let title = comment.title;
            const commentsPercentage = comment.percentage == -1 ? 'NODATA' : comment.percentage;
            data.series[data.nextIndex].data.push(commentsPercentage);
            data.series[data.nextIndex].dataOffset.push({ id: title, setId: quickCommentsItem.id, value: commentsPercentage });
            data.seriesIdentifier[data.nextIndex].push({ id: title, setId: quickCommentsItem.id });
            if (quickCommentsItem.id >= 0 && quickCommentsItem.name) {
              title += " / " + this.layoutService.translateText(quickCommentsItem.name);
            }

            title = title ? title : comment.title;
            if (!data.categoryAxis.categories.includes(title)) {
              data.categoryAxis.categories.push(title);
              data.categoryAxis.categoryOffset.push({ id: comment.title, setId: quickCommentsItem.id });
            }
          });
        });

        let maxLength = data.categoryAxis.categoryOffset.length
        const combinedData = data.series.map(() => new Array(maxLength).fill(null));

        data.series.forEach((item, serieIndex) => {
          item.dataOffset.forEach((value, index) => {
            let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
            combinedData[serieIndex][indexOffset] = value.value;
          });
        });

        for (let i = 0; i < combinedData.length; i++) {
          data.series[i].data = combinedData[i];
        }


        filterCount++;
        data.series[data.nextIndex].name = [`${this.data.filters && this.data.filters[data.series[data.nextIndex].serieIndex] ? this.data.filters[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + filterCount}`];
        data.series[data.nextIndex].filterName = [`${this.data.filters && this.data.filters[data.series[data.nextIndex].serieIndex] ? this.data.filters[data.series[data.nextIndex].serieIndex].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + filterCount}`];
        data.series[data.nextIndex].filterNum = filterCount;

        data.categoryAxis.rotation = 0;
        data.categoryAxis.maxDivisions = 12;
        data.setId = chartId;
        data.nextIndex++;
        chart.chartOptions = data;
        chart.chartDatamani();

        let gridData: any[] = this.results[chartIndex].gridData;
        let fields = this.results[chartIndex].fields;
        gridData = Object.assign([], gridData);

        quickCommentsAnalysis.quickCommentsAnalysisList.forEach((element) => {
          let quickComments = element.list;
          let multiName = '';
          let elementId = '';
          if (quickCommentsAnalysis.filterType && quickCommentsAnalysis.filterType != 'single') {
            multiName = element.name;
            elementId = element.id;
            if (element.list.length == 0 && element.noData == true) {
              multiName = 'EVALUATION.NO_DATA'
              elementId = 'nodata';
            }

            fields.push(
              { 'field': `totalTouchedCommentsforfilter${index + 1}_${elementId}`, 'title': this.layoutService.translateText('CHECK.EVALUATION.TOTAL_TOUCHED'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`, 'multiName': multiName },
              { 'field': `totalQuestionnairesforfilter${index + 1}_${elementId}`, 'title': this.layoutService.translateText('CHECK.EVALUATION.TOTAL_QUESTIONNAIRE'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`, 'multiName': multiName },
              { 'field': `percentageforfilter${index + 1}_${elementId}`, 'title': this.layoutService.translateText('CHECK.EVALUATION.PERCENTAGE'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}`, 'multiName': multiName }
            );

            quickComments.forEach((item, i) => {
              if (this.data.commentIds.length > 0) {
                if (!this.data.commentIds.includes(item.id)) {
                  return;
                }
              }

              if (this.comments.length > 0) {
                if (this.comments.findIndex(res => res.id == item.id) == -1) {
                  return;
                }
              } else {
                return;
              }

              let comment = gridData.find(res => res.id == item.id);
              let commentPercentage = item.percentage != -1 ? `${item.percentage.toFixed(2)}%` : "N/A";
              if (!comment) {
                item[`totalTouchedCommentsforfilter${index + 1}_${elementId}`] = item.touchedComments;
                item[`totalQuestionnairesforfilter${index + 1}_${elementId}`] = item.totalQuestionnairesforfilter;
                item[`percentageforfilter${index + 1}_${elementId}`] = commentPercentage;
                gridData.push(item);
              } else {
                comment[`totalTouchedCommentsforfilter${index + 1}_${elementId}`] = item.touchedComments;
                comment[`totalQuestionnairesforfilter${index + 1}_${elementId}`] = item.totalQuestionnairesforfilter;
                comment[`percentageforfilter${index + 1}_${elementId}`] = commentPercentage;
              }
            });
          } else {
            fields.push(
              { 'field': `totalTouchedCommentsforfilter${index + 1}`, 'title': this.layoutService.translateText('CHECK.EVALUATION.TOTAL_TOUCHED'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` },
              { 'field': `totalQuestionnairesforfilter${index + 1}`, 'title': this.layoutService.translateText('CHECK.EVALUATION.TOTAL_QUESTIONNAIRE'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` },
              { 'field': `percentageforfilter${index + 1}`, 'title': this.layoutService.translateText('CHECK.EVALUATION.PERCENTAGE'), 'group': `${this.data.filters && this.data.filters[index] ? this.data.filters[index].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (index + 1)}` }
            );

            quickComments.forEach((item, i) => {
              if (this.data.commentIds.length > 0) {
                if (!this.data.commentIds.includes(item.id)) {
                  return;
                }
              }

              if (this.comments.length > 0) {
                if (this.comments.findIndex(res => res.id == item.id) == -1) {
                  return;
                }
              } else {
                return;
              }

              let comment = gridData.find(res => res.id == item.id);
              let commentPercentage = item.percentage != -1 ? `${item.percentage.toFixed(2)}%` : "N/A";
              if (!comment) {
                item[`totalTouchedCommentsforfilter${index + 1}`] = item.touchedComments;
                item[`totalQuestionnairesforfilter${index + 1}`] = item.totalQuestionnairesforfilter;
                item[`percentageforfilter${index + 1}`] = commentPercentage;
                gridData.push(item);
              } else {
                comment[`totalTouchedCommentsforfilter${index + 1}`] = item.touchedComments;
                comment[`totalQuestionnairesforfilter${index + 1}`] = item.totalQuestionnairesforfilter;
                comment[`percentageforfilter${index + 1}`] = commentPercentage;
              }
            });
          }
        });

        filterTableCount += 1;
        this.results[chartIndex].gridData = gridData;
        this.results[chartIndex].fields = fields;
        this.results[chartIndex].resultChart = chart;

        setTimeout(() => {
          let complianceChart = this.compliance.charts.get(chartIndex);
          if (complianceChart) {
            complianceChart.chartDatamani();
          }
          this.compliance.setComplianceFields(this.results[chartIndex], 3, 3);
          this.compliance.setFilters(this.filters.toArray());

          if (index == res.length - 1) {
            this.compliance.resultsLoader.next(cloneDeep(this.results));
            if (this.exportTag) {
              this.exportTag.results = Object.assign([], this.results);
            }
          }

        }, 500);
      });

      this.evaluationLoaded = true;
      this.layoutService.showLoader = false;
      setTimeout(() => { this.initializeFilters(); }, 1000);
    }, 1000);

  }

  initializeFilters() {
    this.selectedSeries = [];
    this.filters.forEach((filter, index) => {
      filter.visible = true;
    });

    this.evaluationService.getHygieneCheckEvaluationSeries(this.userID, this.reportKey).subscribe((seriesData: any) => {
      if (!seriesData || seriesData.selectedSeries == null) {
        this.layoutService.showLoader = false;
        return;
      }
      this.selectedSeries = JSON.parse(seriesData.selectedSeries);
      if (this.selectedSeries.length == 0) {
        this.layoutService.showLoader = false;
        return;
      }

      let chartSeries = JSON.parse(seriesData.selectedSeries);
      setTimeout(() => {
        chartSeries.forEach(serie => {
          if (typeof serie === 'number') {
            this.charts.forEach((chart) => {
              this.compliance.toggleVisibility(chart.chartId, { index: serie });
              chart.internalToggleSerie({ index: serie });
            });
          } else {
            let chart = this.charts.find(c => c.chartId === serie.chartId);
            if (!chart) return;
            serie.series.forEach((serie) => {
              chart.internalToggleSerie({ index: serie });
              this.compliance.toggleVisibility(chart.chartId, { index: serie });
            });
            this.filters.forEach((filter, index) => {
              if (index != serie.series) return;
              if (filter.visible == undefined) filter.visible = true;
              filter.visible = !filter.visible;
            });
          }
        });
      }, 1500);
    }, (error) => {
      this.layoutService.showLoader = false;
    }, () => {
      this.layoutService.showLoader = false;
    });
  }

  anyWardIsSelected() {
    for (let filterComponent of this.filters.toArray()) {
      if (filterComponent.isWardSelected()) {
        return true;
      }
    }
    return false;
  }

  onFilterRemoved(filterIndexToRemove: number) {
    const index = this.filterIndices.indexOf(filterIndexToRemove);

    if (index !== -1) {
      this.filterIndices.splice(index, 1);
    }

    this.showCompareCard = this.filterIndices.length > 1;
    this.compliance.showCompareCard = this.showCompareCard;
    if (this.userHasFilter) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }

  exportAs() {
    this.clickImageBtn = true;
  }

  excelDownload() {
    this.clickExcelBtn = true;
  }

  downloadKendoPDF() {
    this.clickPdfBtn = true;
  }

  resetFilters() {
    this.multiselect.reset();
    this.comments = this.originalComments;
    this.filterDetails = [this.filterDetails[0]];
    this.filterIndices = [0];
    this.filters.toArray()[0].resetFilter(true);
    this.selectedQuestionnaires = [];
    this.onCommentChange(0, false);
    this.layoutService.showLoader = true;
    var seriesData = {
      userId: this.userID,
      complianceType: this.reportKey,
      selectedSeries: null
    };

    this.evaluationService.updateHygieneCheckEvaluationSeries(seriesData).subscribe(() => {
      setTimeout(() => { this.evaluate(true); }, 1500);
    }, () => { }, () => { });
  }


  onSeriesClick(serie: any, resultIndex: number) {
    let chart = this.charts.find(c => c.chartId == serie.chartId);
    chart.series.get(serie.index).options.visible = serie.visible;

    this.filters.forEach((filter, index) => {
      if (index != serie.index) return;
      if (filter.visible == undefined) filter.visible = true;
      filter.visible = !filter.visible;
    });

    this.compliance.toggleVisibility(serie.chartId, serie);

    let visibilitySeries = [];

    this.charts.forEach((chart) => {
      let c = {
        chartId: chart.chartId,
        series: chart.series.map((s, index) => ({ series: s, index }))
          .filter(s => s.series.options.visible === false)
          .map(s => s.index)
      }
      visibilitySeries.push(c);
    })

    var seriesData = {
      userId: this.userID,
      complianceType: this.reportKey,
      selectedSeries: JSON.stringify(visibilitySeries)
    };

    this.evaluationService.updateHygieneCheckEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
  }

  onFilterSaved() {
    // Buscar nombres duplicados y renombrar los duplicados
    const renamedFilters: string[] = [];
    var filters = this.filters.toArray();
    // Recorre desde el último hasta el primero
    for (let i = filters.length - 1; i >= 0; i--) {
      const currentName = filters[i].filterName?.trim() || '';
      for (let j = 0; j < filters.length; j++) {
        if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
          // Si hay coincidencia, renombra el actual
          const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
          filters[i].filterName = translatedFilterName;
          filters[i].setFilterName = translatedFilterName;          
          renamedFilters.push(translatedFilterName);
          break;
        }
      }
    }

    if (renamedFilters.length > 0) {
        const f = renamedFilters[renamedFilters.length - 1];
        const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
        this.layoutService.showWarning(msg);
    }
    this.evaluate(true);
  }

  onRefreshClick(noDataFound: boolean) {
    if (noDataFound) {
      return;
    }

    this.evaluate(true);
  }

  saveSummarisedReport() {
    if (this.userHasFilter) {
      this.evaluate(false);
    }
  }

  trackLoop(index: number, item: any) {
    return item;
  }

  onCommentChange(comment, evaluate: boolean = true) {
    if (comment == 0) {
      this.selectedComment = {
        id: "all",
        title: "CHECK.EVALUATION.ALL_COMMENTS"
      }
    } else {
      this.selectedComment = comment;
    }

    if (evaluate) {
      this.layoutService.showLoader = true;
      setTimeout(() => { this.evaluate(true); }, 1000);
    }
  }
}
